export default __webpack_public_path__ + "static/media/38.936e4626.png";